module.exports = __webpack_public_path__ + "img/WechatCode.e052000f.jpeg";